import type { ParseKeys } from 'i18next';
import { useTranslation } from 'react-i18next';
import i18n from '~/i18n';

/**
 * Console strings are English only (`admin.*`, owner decision), all in
 * `en/translation.json`. `ParseKeys` is bridged by a cast here rather than at
 * every call site; strings.test.ts checks every literal key exists.
 */
export type PeopleKey = `admin.${string}`;

/** Module-level lookup for column headers, which are built outside React. */
export function tr(key: PeopleKey, options?: Record<string, unknown>) {
  return i18n.t(key as ParseKeys, {
    interpolation: { escapeValue: false },
    ...options,
  }) as string;
}

/** A key built at runtime (a profile type, an error code) with its fallback. */
export function trDynamic(key: string, fallback: string) {
  return i18n.t(key as ParseKeys, { defaultValue: fallback }) as string;
}

/** The in-component form of `tr`: re-renders when the language changes. */
export function usePeopleT(): typeof tr {
  useTranslation();
  return tr;
}
